const whatsappCampaignSearch = {
  currentPage: 1,
  currentEstateId: null,
  selectedVendorIds: new Set(),
  deselectedVendorIds: new Set(),

  initialize() {
    this.bindEvents();
  },

  bindEvents() {
    // Estate search form submission
    $('#estate-search-form').on('submit', (e) => {
      console.log('Estate search form submitted');
      e.preventDefault();
      this.searchEstateVendors();
    });

    // Vendor checkbox handling
    $(document).on('change', '.vendor-checkbox', (e) => {
      this.handleVendorSelection(e.target);
    });

    // Select All / Deselect All
    $('#select-all-vendors').on('click', () => this.selectAllVendors());
    $('#deselect-all-vendors').on('click', () => this.deselectAllVendors());

    // Template selection
    $('#whatsapp-template').on('change', (e) => {
      // this.handleTemplateSelection(e.target.value);
      this.fetchTemplatePreview(e.target.value);
    });

    // Pagination
    $('#prev-page').on('click', () => this.previousPage());
    $('#next-page').on('click', () => this.nextPage());

    // Create campaign button
    $('#create-campaign-btn').on('click', () => this.submitCampaign());
  },

  searchEstateVendors() {
    console.log('Searching for vendors...');
    const estateId = $('#estate_id').val();

    if (!estateId) {
      alert('Please select an estate');
      return;
    }

    this.currentEstateId = estateId;
    this.currentPage = 1;
    this.selectedVendorIds.clear();
    this.deselectedVendorIds.clear();
    this.fetchVendors(estateId, 1);
  },

  fetchVendors(estateId, page) {
    console.log(`Fetching vendors for estate ${estateId} on page ${page}`);
    $.ajax({
      url: '/whatsapp_campaigns/search',
      type: 'GET',
      data: { estate_id: estateId, page: page },
      dataType: 'json',
      success: (response) => {
        this.renderVendorTable(response.vendors);
        this.updatePagination(response.pagination);
        $('#campaign-creation-section').show();
      },
      error: (error) => {
        if (error.status === 400) {
          alert('Please select an estate');
        } else if (error.status === 404) {
          alert('Estate not found');
        } else {
          alert('Error fetching vendors: ' + error.statusText);
        }
      }
    });
  },

  renderVendorTable(vendors) {
    const vendorTableHtml = vendors.length > 0 ? vendors.map(vendor => `
      <tr>
        <td>
          <div class="ui checkbox">
            <input type="checkbox" class="vendor-checkbox" value="${vendor.id}"><label></label>
          </div>
        </td>
        <td>${vendor.name}</td>
        <td>${vendor.company_name || ''}</td>
        <td>${vendor.phone_numbers.join(', ')}</td>
      </tr>
      `).join('') : '<p class="placeholder">No vendors found with valid mobile numbers</p>';

    $('#vendor-table-body').html(vendorTableHtml);

    // Default to checked unless user explicitly deselected before.
    vendors.forEach(vendor => {
      const shouldCheck = !this.deselectedVendorIds.has(vendor.id);
      $(`.vendor-row-checkbox[value="${vendor.id}"]`).prop('checked', shouldCheck);
      if (shouldCheck) {
        this.selectedVendorIds.add(vendor.id);
      } else {
        this.selectedVendorIds.delete(vendor.id);
      }
    });
  },

  handleVendorSelection(checkbox) {
    const vendorId = parseInt(checkbox.value);

    if (checkbox.checked) {
      this.selectedVendorIds.add(vendorId);
      this.deselectedVendorIds.delete(vendorId);
    } else {
      this.selectedVendorIds.delete(vendorId);
      this.deselectedVendorIds.add(vendorId);
    }

    this.updateVendorCount();
    this.updateCreateButtonState();
  },

  selectAllVendors() {
    $('.vendor-checkbox').prop('checked', true).each((_, checkbox) => {
      const vendorId = parseInt(checkbox.value);
      this.selectedVendorIds.add(vendorId);
      this.deselectedVendorIds.delete(vendorId);
    });
    this.updateVendorCount();
    this.updateCreateButtonState();
  },

  deselectAllVendors() {
    $('.vendor-checkbox').prop('checked', false).each((_, checkbox) => {
      const vendorId = parseInt(checkbox.value);
      this.selectedVendorIds.delete(vendorId);
      this.deselectedVendorIds.add(vendorId);
    });
    this.updateVendorCount();
    this.updateCreateButtonState();
  },

  updateVendorCount() {
    $('#vendor-count').text(this.selectedVendorIds.size);
  },

  handleTemplateSelection(templateId) {
    if (!templateId) {
      $('#template-body').text('');
      $('#template-preview').hide();
      this.updateCreateButtonState();
      return;
    }

    const selectedOption = $('#whatsapp-template option:selected');
    const templateBody = selectedOption.data('template-body');
    if (templateBody) {
      $('#template-body').text(templateBody);
      $('#template-preview').show();
    } else {
      $('#template-body').text('');
      $('#template-preview').hide();
    }
    this.updateCreateButtonState();
  },

  fetchTemplatePreview(templateId) {
    if (!templateId) return;

    fetch('/whatsapp_templates/' + templateId + '/preview.js?', {
      headers: { 'Accept': 'text/javascript' }
    })
      .then(response => response.text())
      .then(js => {
        eval(js);
      });
  },

  updateCreateButtonState() {
    const hasVendors = this.selectedVendorIds.size > 0;
    const hasTemplate = $('#whatsapp-template').val() !== '';

    $('#create-campaign-btn').prop('disabled', !(hasVendors && hasTemplate));
  },

  updatePagination(pagination) {
    $('#page-info').text(`Page ${pagination.current_page} of ${pagination.total_pages}`);
    $('#prev-page').prop('disabled', pagination.current_page === 1);
    $('#next-page').prop('disabled', pagination.current_page === pagination.total_pages);

    if (pagination.total_pages > 1) {
      $('#pagination-controls').show();
    } else {
      $('#pagination-controls').hide();
    }

    this.currentPage = pagination.current_page;
  },

  previousPage() {
    if (this.currentPage > 1) {
      this.fetchVendors(this.currentEstateId, this.currentPage - 1);
    }
  },

  nextPage() {
    this.fetchVendors(this.currentEstateId, this.currentPage + 1);
  },

  submitCampaign() {
    const vendorIds = Array.from(this.selectedVendorIds);
    const templateId = $('#whatsapp-template').val();
    const csrfToken = $('meta[name="csrf-token"]').attr('content');

    if (vendorIds.length === 0) {
      alert('Please select at least one vendor');
      return;
    }

    if (!templateId) {
      alert('Please select a template');
      return;
    }

    // Create a unique campaign name
    const timestamp = new Date().toISOString().slice(0, 10);
    const campaignName = `Campaign - ${timestamp}`;

    // Submit form to create campaign
    const form = $('<form/>', {
      method: 'POST',
      action: '/whatsapp_campaigns',
      html: `
        <input type="hidden" name="authenticity_token" value="${csrfToken || ''}">
        <input type="hidden" name="whatsapp_campaign[name]" value="${campaignName}">
        <input type="hidden" name="whatsapp_campaign[estate_id]" value="${this.currentEstateId}">
        <input type="hidden" name="whatsapp_campaign[whatsapp_template_id]" value="${templateId}">
        ${vendorIds.map(id => `<input type="hidden" name="whatsapp_campaign[selected_vendor_ids][]" value="${id}">`).join('')}
      `
    });

    $('body').append(form);
    form.submit();
  }
};

window.whatsappCampaignSearch = whatsappCampaignSearch;
